module.exports = __webpack_public_path__ + "static/flags/HU-067c4553801967a18d7cfbac63b52723.gif";